export const SHARE_DOC_DIALOG_SHOWN = 'general.shareDocDialogShown';
